import { UserProfilePicture } from "@common/components/ProfilePicture/component";
import Tabs, { TabContent, TabHeader, TabsContent, TabsHeader } from "@common/controls/Tabs/component";
import { useI18n } from "@common/hooks/i18n";
import React from "react";
import { type Courses } from "../../types";
import Downloads from "./Downloads";
import Faq from "./Faq";

export type Props = {
  allFaq: Courses.LessonFaq[];
  data: Courses.CourseLessonAppState;
  onTabActivated?: (index: number) => void;
  instructorUserPictureSize?: number;
};

const LessonAdditionalInfo = (props: Props) => {
  const i18n = useI18n();

  return (
    <Tabs className="lesson_additional_info" onTabActivated={props.onTabActivated}>
      <TabsHeader>
        {!!props.data.lesson.postscript && <TabHeader label={i18n.postscript} />}
        {!!props.data.downloads.length && <TabHeader label={i18n.downloads} />}
        {!!props.allFaq.length && <TabHeader label={i18n.faq} />}
        <TabHeader label={i18n.instructor} />
      </TabsHeader>
      <TabsContent>
        {!!props.data.lesson.postscript && (
          <TabContent>
            <div dangerouslySetInnerHTML={{ __html: props.data.lesson.postscript }} />
          </TabContent>
        )}
        {!!props.data.downloads.length && (
          <TabContent>
            <Downloads downloads={props.data.downloads} />
          </TabContent>
        )}
        {!!props.allFaq.length && (
          <TabContent>
            <Faq allFaq={props.allFaq} lessonId={props.data.lesson.id} />
          </TabContent>
        )}
        <TabContent>
          <div className="instructor">
            <UserProfilePicture
              size={props.instructorUserPictureSize ?? 50}
              profilePictureMediaSourceId={props.data.lesson.instructorProfileMediaSourceId}
              profilePictureMediaSourceKey={props.data.lesson.instructorProfileMediaSourceKey}
              firstName={props.data.lesson.instructorFirstName}
              lastName={props.data.lesson.instructorLastName}
              email={null}
            />
            <p
              className="biography"
              dangerouslySetInnerHTML={{ __html: props.data.lesson.instructorBiography ?? "" }}
            ></p>
          </div>
        </TabContent>
      </TabsContent>
    </Tabs>
  );
};

export default LessonAdditionalInfo;
